import React from 'react'

import { FaShippingFast } from 'react-icons/fa'
import { GiReturnArrow, GiCardExchange } from 'react-icons/gi'
import { BiSupport } from 'react-icons/bi'


function Features() {
    return (
        <section className='features'>
            <div className="container">
                <h1 className="section-title">Features</h1>
                <div className="feature">
                    <div className="feature-icon">
                        <FaShippingFast />
                    </div>
                    <div className="feature-info">
                        <h2 className='feature-name'>Shipping</h2>
                        <p className="feature-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, explicabo.</p>
                    </div>
                </div>
                <div className="feature">
                    <div className="feature-icon">
                        <GiReturnArrow />
                    </div>
                    <div className="feature-info">
                        <h2 className='feature-name'>Return</h2>
                        <p className="feature-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, explicabo.</p>
                    </div>
                </div>
                <div className="feature">
                    <div className="feature-icon">
                        <GiCardExchange />
                    </div>
                    <div className="feature-info">
                        <h2 className='feature-name'>Exchange</h2>
                        <p className="feature-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, explicabo.</p>
                    </div>
                </div>
                <div className="feature">
                    <div className="feature-icon">
                        <BiSupport />
                    </div>
                    <div className="feature-info">
                        <h2 className='feature-name'>Contact Support</h2>
                        <p className="feature-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, explicabo.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Features